import React from 'react';

const AcessoBloqueado = () => {
  const handleLogout = () => {
    localStorage.removeItem('agrolink_token');
    window.location.href = '/login';
  };

  return (
    <div data-testid="acesso-bloqueado-page" className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="w-20 h-20 mx-auto bg-orange-100 rounded-full flex items-center justify-center">
          <svg className="w-10 h-10 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>
        
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Acesso Suspenso</h1>
          <p className="mt-2 text-gray-600">
            Sua assinatura esta inativa ou pendente de pagamento. 
            Entre em contato com o administrador para regularizar.
          </p>
        </div>

        <div className="bg-white rounded-xl p-5 shadow-sm border space-y-3">
          <div className="flex items-center gap-3 text-left">
            <svg className="w-5 h-5 text-emerald-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            <div>
              <p className="text-sm font-medium text-gray-900">E-mail</p>
              <p className="text-sm text-gray-500">suporte@agrolinkbr.com.br</p>
            </div>
          </div>
          <div className="flex items-center gap-3 text-left">
            <svg className="w-5 h-5 text-emerald-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div>
              <p className="text-sm font-medium text-gray-900">Horario de Atendimento</p>
              <p className="text-sm text-gray-500">Seg a Sex, 8h as 18h</p>
            </div>
          </div>
        </div>

        <button
          data-testid="btn-logout"
          onClick={handleLogout}
          className="px-6 py-2 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
        >
          Sair
        </button>
      </div>
    </div>
  );
};

export default AcessoBloqueado;
